import { useMutation, useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';
import { generateGroupInfoQueryOptions } from '@/hooks/groups/use-group-info';
import type { RespondedType, ResponseError } from '@/models/response';
import { addToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';

export default function useUpdateGroupAllBan(groupId: Nullable<number>) {
  const queryClient = useQueryClient();

  return useMutation<RespondedType, ResponseError, boolean>({
    mutationKey: ['/UpdateGroupAllBan', groupId],
    mutationFn: (params) =>
      fetcher('/UpdateGroupAllBan', { AllBan: Number(params), GroupID: groupId }, { validResponseCodes: [0] }),
    onSuccess: (_, params) => {
      if (groupId) {
        queryClient.setQueryData(generateGroupInfoQueryOptions(groupId).queryKey, (data) =>
          produce(data, (draft) => {
            if (!draft?.GroupData) return draft;

            draft.GroupData.AllBan = Boolean(params);
          }),
        );
      }
    },
    onSettled: (data, error) =>
      addToast({
        type: data ? 'success' : 'error',
        message: data?.Msg ?? error?.message,
      }),
  });
}
